import Notice from "@buildpy/ui/notice";
import { Button } from "@buildpy/ui/button";
import { Link } from "@/lib/nav";
import { useNativeApp } from "@/lib/use-native-app";
import { START_PICK_HREF } from "@/pages/start/start-target";

// 없는 주소(legacy 는 Next 기본 404) — 무엇이 없는지와 돌아갈 길만 준다 · 앱 안이면 「처음으로」 가 고르는 화면(/ → /start → 기억한 링크 루프를 피한다).
const NotFound = () => {
  const native = useNativeApp();
  return (
    <main className="flex min-h-[60vh] items-center justify-center p-4">
      <Notice
        actions={
          <Button asChild size="sm" variant="outline">
            <Link href={native ? START_PICK_HREF : "/"}>처음으로</Link>
          </Button>
        }
        body="주소가 잘못되었거나 없어진 화면입니다."
        title="페이지를 찾지 못했습니다"
      />
    </main>
  );
};

export default NotFound;
